var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.buttonClass,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),_c('ClipLoader',{attrs:{"loading":_vm.loading,"color":_vm.spinnerColor,"size":"29px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }